import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";

/** Whether the walked unit's original product has a mapping, picking a map-mode transform's branch. */
export const resolveTransformProductBranch = {
  name: "resolveTransformProductBranch" as const,
  input: z.union([
    z.object({ sessionItemId: processingSessionItemIdFormat.schema }),
    z.object({ itemSessionId: processingSessionIdFormat.schema }),
  ]),
  output: z.object({ mapped: z.boolean() }),
};
